//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
'use client';

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';
import ProductBreakthrough from '@/app/components/LegacyLandingPage/components/ProductBreakthrough';

import FitnessFeatures from './_components/FitnessFeatures';
import FitnessHero from './_components/FitnessHero';
import FitnessPress from './_components/FitnessPress';
import FitnessPressAccolades from './_components/FitnessPressAccolades';
import FitnessTestimonials from './_components/FitnessTestimonials';

const Content = () => {
  return (
    <>
      <InverseHeader enter>
        <FitnessHero />
        <ProductBreakthrough />
      </InverseHeader>
      <FitnessFeatures />
      <FitnessPress />
      <FitnessTestimonials />
      <FitnessPressAccolades />
    </>
  );
};

export default Content;
